
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_13bmg_289",
  "arrow-outer": "awsui_arrow-outer_xjuzf_13bmg_293",
  "arrow-inner": "awsui_arrow-inner_xjuzf_13bmg_293",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_13bmg_335",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_13bmg_335",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_13bmg_338",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_13bmg_338",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_13bmg_341",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_13bmg_341",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_13bmg_341",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_13bmg_341",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_13bmg_344",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_13bmg_344",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_13bmg_344",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_13bmg_344",
  "body": "awsui_body_xjuzf_13bmg_492",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_13bmg_528",
  "body-variant-chart": "awsui_body-variant-chart_xjuzf_13bmg_531",
  "has-dismiss": "awsui_has-dismiss_xjuzf_13bmg_536",
  "dismiss": "awsui_dismiss_xjuzf_13bmg_541",
  "dismiss-control": "awsui_dismiss-control_xjuzf_13bmg_549",
  "header-row": "awsui_header-row_xjuzf_13bmg_553",
  "header": "awsui_header_xjuzf_13bmg_553",
  "content": "awsui_content_xjuzf_13bmg_578",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_13bmg_586",
  "container": "awsui_container_xjuzf_13bmg_734",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_13bmg_745",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_13bmg_745",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_13bmg_745",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_13bmg_750",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_13bmg_750",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_13bmg_750",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_13bmg_755",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_13bmg_755",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_13bmg_760",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_13bmg_760",
  "container-body": "awsui_container-body_xjuzf_13bmg_766",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_13bmg_806",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_13bmg_811",
  "fixed-width": "awsui_fixed-width_xjuzf_13bmg_814",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_13bmg_818",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_13bmg_825",
  "container-arrow": "awsui_container-arrow_xjuzf_13bmg_745",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_13bmg_875",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_13bmg_1",
  "refresh": "awsui_refresh_xjuzf_13bmg_1069",
  "root": "awsui_root_xjuzf_13bmg_1091",
  "no-wrap": "awsui_no-wrap_xjuzf_13bmg_1123",
  "root-filtering-token": "awsui_root-filtering-token_xjuzf_13bmg_1127",
  "trigger": "awsui_trigger_xjuzf_13bmg_1131",
  "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_13bmg_1138",
  "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_13bmg_1146",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_13bmg_1146",
  "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_13bmg_1214",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_13bmg_1218",
  "hover-area": "awsui_hover-area_xjuzf_13bmg_1222"
};
  